/**
 * Accessibility behavior for autoplaying slideshows (Horizon renders its own play/pause control):
 * - suspend rotation while keyboard focus is inside, resume on leave (unless the user paused it)
 * - start paused when the user prefers reduced motion
 * - don't announce every auto-advance to screen readers (aria-live off while rotating)
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function syncLive(slideshow) {
  slideshow.setAttribute('aria-live', slideshow.hasAttribute('paused') ? 'polite' : 'off');
}

function enhance(slideshow) {
  if (slideshow.dataset.wrbA11y || !slideshow.hasAttribute('autoplay')) return;
  slideshow.dataset.wrbA11y = 'true';

  slideshow.addEventListener('focusin', () => slideshow.suspend());
  slideshow.addEventListener('focusout', (event) => {
    if (!slideshow.contains(/** @type {Node} */ (event.relatedTarget))) slideshow.resume();
  });

  new MutationObserver(() => syncLive(slideshow)).observe(slideshow, { attributes: true, attributeFilter: ['paused'] });

  if (reduceMotion.matches) slideshow.pause();
  syncLive(slideshow);
}

function init() {
  document.querySelectorAll('slideshow-component[autoplay]').forEach(enhance);
}

customElements.whenDefined('slideshow-component').then(init);
document.addEventListener('shopify:section:load', init);
